import { transformAddressString } from './AddressTransformerPerRetailUnit';
import { transformValues as baseTransformValues } from './transformValues';

export function transformFields(response, addressFieldMap) {
  if (!response) {
    return false;
  }
  return Object.keys(addressFieldMap).reduce((data, fieldName) => {
    const locateFieldNames =
      typeof addressFieldMap[fieldName] === 'string'
        ? [addressFieldMap[fieldName]]
        : addressFieldMap[fieldName];

    if (!locateFieldNames) {
      data[fieldName] = undefined;
      return data;
    }

    let nextSeparator = '';

    data[fieldName] = locateFieldNames.reduce(
      (concatenatedValue, locateFieldName) => {
        const separatorMatch = locateFieldName.match(/^\{(.*)\}$/);

        if (separatorMatch) {
          nextSeparator = separatorMatch[1];
          return concatenatedValue;
        }

        const value = response[locateFieldName];
        const separator = concatenatedValue ? nextSeparator : '';

        const newConcatenatedValue = value
          ? `${concatenatedValue}${separator}${value}`
          : concatenatedValue;

        nextSeparator = '';
        return newConcatenatedValue;
      },
      ''
    );
    return data;
  }, {});
}

export function transformValues(data, addressValueMap) {
  return baseTransformValues(data, addressValueMap, true);
}

export function transformOptions(response) {
  if (!response || !response.suggestions || !response.suggestions.length) {
    return false;
  }
  const options = [];
  const { suggestions } = response;

  for (let i = 0; i < suggestions.length; i++) {
    options.push({
      id: response.suggestions[i].isCapturable
        ? response.suggestions[i].captureId
        : response.suggestions[i].captureGroupId,
      label: transformAddressString(response.suggestions[i].text),
      subLabel: response.suggestions[i].subText || '',
      isCapturable: response.suggestions[i].isCapturable
    });
  }
  return options;
}
